import camelize from 'underscore.string/camelize';

angular
  .module 'filters'
  .filter 'camelize', ->
    (data) ->
      camelize(data)
